import { useEffect, useState } from 'react';
import { ADVISOR_CONSENT_EVENT, ADVISOR_CONSENT_KEY, makeAdvisorConsent, parseAdvisorConsent } from '../lib/advisor-consent';

let pageChoice: string | null = null;
export function readAdvisorConsent() {
  try { return parseAdvisorConsent(pageChoice ?? localStorage.getItem(ADVISOR_CONSENT_KEY)); }
  catch { return parseAdvisorConsent(pageChoice); }
}
export function saveAdvisorConsent(allowed: boolean) {
  pageChoice = JSON.stringify(makeAdvisorConsent(allowed));
  try { localStorage.setItem(ADVISOR_CONSENT_KEY, pageChoice); } catch { /* Applies to this visit if storage is unavailable. */ }
  window.dispatchEvent(new Event(ADVISOR_CONSENT_EVENT));
}
export function useAdvisorConsent() {
  const [choice, setChoice] = useState(readAdvisorConsent);
  useEffect(() => {
    function refresh() { setChoice(readAdvisorConsent()); }
    function storage(event: StorageEvent) {
      if (event.key === ADVISOR_CONSENT_KEY || event.key === null) { pageChoice = null; refresh(); }
    }
    const timer = choice ? setTimeout(refresh, Math.min(choice.expiresAt - Date.now(), 2_147_483_647)) : undefined;
    window.addEventListener(ADVISOR_CONSENT_EVENT, refresh);
    window.addEventListener('storage', storage);
    window.addEventListener('focus', refresh);
    return () => { clearTimeout(timer); window.removeEventListener(ADVISOR_CONSENT_EVENT, refresh); window.removeEventListener('storage', storage); window.removeEventListener('focus', refresh); };
  }, [choice]);
  return choice;
}
